import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import NewVLPHeader from "./vlp/components/header/NewVLPHeader";
import MobileHeader from "./vlp/components/header/MobileHeader";
import { isMobile } from "react-device-detect";
import CommonLoader from "./vlp/components/common/CommonLoader";

import { appRoutes } from "./routesConfig";
import { GetLoggedInUser } from "./services/usersService";

export default function VLP() {
  const drawerWidth = 20;
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchUser() {
      const u = await GetLoggedInUser();
      setUser(u);
    }
    fetchUser();
  }, []);

  const hasPermission = (permission, overridePermissions = []) => {
    if (!permission) return true; // public route

    // Check route-specific override chain (e.g. isMicroManageAdmin → isAdmin → isSuperAdmin)
    const hasOverride = overridePermissions.some(
      (override) => user?.permissions?.[override] || user?.[override]
    );
    if (hasOverride) return true;

    // Fall back to the specific permission
    return !!(user?.permissions?.[permission] || user?.[permission]);
  };


  // Optionally: loading state
  if (!user) return <><CommonLoader loading={!user} /></>;

  return (
    <Box sx={{ display: "flex" }} className="vlp-main-component">
      {isMobile ? <MobileHeader /> : <NewVLPHeader />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          padding: 1,
          marginLeft: isMobile ? 0 : `${drawerWidth}px`,
          marginTop: isMobile ? "60px" : 0,
        }}
      >
        <Routes>
          {appRoutes.map(({ path, element, permission, overridePermissions = [], public: isPublic }) => (
            <Route
              key={path}
              path={path}
              element={
                isPublic || hasPermission(permission, overridePermissions) ? (
                  element
                ) : (
                  <Navigate to="/vlp/unauthorized" replace />
                )
              }
            />
          ))}
        </Routes>
      </Box>
    </Box>
  );
}
